import * as React from 'react';
import * as _ from 'lodash';
import HeaderNavigation from '../../../headers/HeaderNavigation/HeaderNavigation';
import UserInfo from '../../../headers/UserInfo/UserInfo';
import PageHeader from '../../../headers/PageHeader/PageHeader';
import { IProject } from '../../../../models/IProject';
import { Environment } from '../../../../const/environment';
import FilterSwitcher from '../../../components/FilterSwitcher/FilterSwitcher';
import { ConnectedProps, connect } from 'react-redux';
import { IStore } from '../../../../redux/initialState';

type CorpusPageHeaderProps = PropsFromRedux & {
    label?: string
    project: IProject
    environment: Environment
    selectedFormat: string
    onFormatChange: () => void
    onClose: () => void
}

function CorpusPageHeader({ document, label, selectedFormat, onFormatChange, onClose }: CorpusPageHeaderProps) {

    return <PageHeader
        leftPart={
            <React.Fragment>
                <HeaderNavigation
                    projectName={label}
                    className="big-header"
                    cutAfter={50}
                    onBack={onClose}
                />
            </React.Fragment>
        }
        rightPart={
            <React.Fragment>
                {document &&
                    <div className="corpus-page__header">
                        <FilterSwitcher
                            labelIfTrue="Markdown"
                            labelIfFalse="Markdown"
                            offMode={true}
                            labelOnLeftSide={false}
                            hoveredMode={true}
                            onClick={onFormatChange}
                            value={selectedFormat === 'markdown'}
                        />
                    </div>}
                <UserInfo hideBalanceBlock={true} />
            </React.Fragment>
        }
    />;
}



function mapStateToProps({ corpus }: IStore, ownProps) {
    return {
        corpusId: corpus.corpusId,
        document: corpus.document,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(CorpusPageHeader);